import request from "../utils/request";
const { swSewagePath } = window.globalConfig;

export default class SystemApi {
  // 业务类型列表
  static selectWithClassifyKeys = (params) => {
    return request.post(
      `/${swSewagePath}/api/dict/selectWithClassifyKeys`,
      params,
    );
  };

  /**
   * 创建字典表
   */
  static createDict = (params) => {
    return request.post("/sw-sewage/api/0/dict/create", params);
  };

  /**
   * 删除
   */
  static deleteByIdDict = (params) => {
    return request.post("/sw-sewage/api/0/dict/deleteById", params);
  };

  /**
   *
   * 查询 根据ID
   */
  static getById = (params) => {
    return request.post("/sw-sewage/api/0/dict/getById", params);
  };

  /**
   * 查询所有字典分类
   */
  static selectAllClassify = (params) => {
    return request.post("/sw-sewage/api/0/dict/selectAllClassify", params);
  };

  /**
   * 更新
   */
  static updateDict = (params) => {
    return request.post("/sw-sewage/api/0/dict/update", params);
  };

  /**
   * 字典表分页查询
   */
  static selectByPage = (params) => {
    return request.post("/sw-sewage/api/0/dict/selectByPage", params);
  };

  /**
   *  获取流程id
   */

  static getFlowableId = (params) => {
    return request.appid(
      `/ocp-saas/api/0/dictData/getFlowableId?dictType=${params.dictType}&dictKey=${params.dictKey}`,
    );
  };

  /**
   *  单点登录
   */

  static ssoLogin = (params) => {
    return request.post(`/ocp-saas/system/0/admin/sso/login`, params);
  };

  /**
   *  流程配置
   */
  static getAllProcess = () => {
    return request.appid(`/sw-flowable/api/0/comm/getAllProcess`);
  };

  // 获取模板的流程
  static showAllFlowableInfo = () => {
    return request.appid(
      `/ocp-saas/flow/app/0/admin/showAllFlowableInfo?name=sw-flowable`,
    );
  };

  // 获取模板的流程分页
  static showAllFlowableList = (params) => {
    return request.post(`/ocp-saas/api/0/dictData/listByPage`, params);
  };

  // 获取模板的流程
  static updateFlowable = (params) => {
    return request.post(`/ocp-saas/api/0/dictData/update`, params);
  };

  // 修改当前模板的流程
  static updateFlowableById = (params) => {
    return request.post(
      `/ocp-saas/flow/app/0/admin/updateFlowableById`,
      params,
    );
  };

  // 获取当前模板的流程图
  static viewProcessImg = (params) => {
    return request.appid(
      `/sw-flowable/api/0/comm/viewProcessImg?id=${params.id}`,
      {
        responseType: "blob",
      },
    );
  };

  // 获取当前模板的流程图
  // static viewProcessImgUrl = () => {
  //     return `/sw-flowable/api/0/comm/viewProcessImg?processDefinitionId=`
  // }

  // 删除流程
  static delFlowableById = (params) => {
    return request.appid(
      `/sw-flowable/api/0/comm/delFlowableById?processDefId=${params.processDefId}&deploymentId=${params.deploymentId}`,
    );
  };

  // 新增设备知识库
  static knowledgeBaseAdd = (params) => {
    return request.post(`/${swSewagePath}/api/0/knowledgeBase/save`, params);
  };

  // 列表设备知识库
  static knowledgeBaseList = (params) => {
    return request.post(`/${swSewagePath}/api/0/knowledgeBase/list`, params);
  };

  // 删除设备知识库
  static knowledgeBaseRemove = (params) => {
    return request.post(`/${swSewagePath}/api/0/knowledgeBase/remove`, params);
  };

  // 修改设备知识库
  static knowledgeBaseUpdate = (params) => {
    return request.post(`/${swSewagePath}/api/0/knowledgeBase/update`, params);
  };

  // 新增设备类型
  static deviceClassifyAdd = (params) => {
    return request.post(`/${swSewagePath}/api/deviceClassify/save`, params);
  };

  // 删除设备类型
  static deviceClassifyRemove = (params) => {
    return request.post(`/${swSewagePath}/api/deviceClassify/remove`, params);
  };

  // 更新设备类型
  static deviceClassifyUpdate = (params) => {
    return request.post(`/${swSewagePath}/api/deviceClassify/update`, params);
  };

  // 设备类型分页列表
  static deviceClassifyList = (params) => {
    return request.post(`/${swSewagePath}/api/deviceClassify/list`, params);
  };

  // 设备类型所有
  static deviceClassifyAll = (params) => {
    return request.post(`/${swSewagePath}/api/deviceClassify/all`, params);
  };

  // 供应商类别所有列表
  static supplierClassifyAll = (params) => {
    return request.post(`/${swSewagePath}/api/0/supplierClassify/all`, params);
  };

  // 供应商类别列表
  static supplierClassifyList = (params) => {
    return request.post(`/${swSewagePath}/api/0/supplierClassify/list`, params);
  };

  // 供应商类别新增
  static supplierClassifySave = (params) => {
    return request.post(`/${swSewagePath}/api/0/supplierClassify/save`, params);
  };

  // 供应商类别删除
  static supplierClassifyRemove = (params) => {
    return request.post(
      `/${swSewagePath}/api/0/supplierClassify/remove`,
      params,
    );
  };

  // 供应商类别更新
  static supplierClassifyUpdate = (params) => {
    return request.post(
      `/${swSewagePath}/api/0/supplierClassify/update`,
      params,
    );
  };

  // 设备供应商新增
  static supplierSave = (params) => {
    return request.post(`/${swSewagePath}/api/0/supplier/save`, params);
  };

  // 设备供应商新增
  static supplierUpdate = (params) => {
    return request.post(`/${swSewagePath}/api/0/supplier/update`, params);
  };

  // 设备供应商分页列表
  static supplierList = (params) => {
    return request.post(`/${swSewagePath}/api/0/supplier/list`, params);
  };

  // 设备供应商删除
  static supplierRemove = (params) => {
    return request.post(`/${swSewagePath}/api/0/supplier/remove`, params);
  };

  // 根据厂站id获取所有供应商
  static supplierAllByStation = (params) => {
    return request.post(`/${swSewagePath}/api/0/supplier/allByStation`, params);
  };

  // 指标设置新增
  static pointIndicatorSave = (params) => {
    return request.post(`/${swSewagePath}/api/0/pointIndicator/save`, params);
  };

  // 指标设置删除
  static pointIndicatorRemove = (params) => {
    return request.post(`/${swSewagePath}/api/0/pointIndicator/remove`, params);
  };

  // 指标设置修改
  static pointIndicatorUpdate = (params) => {
    return request.post(`/${swSewagePath}/api/0/pointIndicator/update`, params);
  };

  // 指标设置分页列表
  static pointIndicatorList = (params) => {
    return request.post(`/${swSewagePath}/api/0/pointIndicator/list`, params);
  };

  // 根据设备ID查询历史数据
  static pointIndicatorListHistory = (params) => {
    return request.post(
      `/${swSewagePath}/api/0/pointIndicator/listHistory`,
      params,
    );
  };

  // 根据设备ID查询设备完好率
  static listIntegrityRate = (params) => {
    return request.post(
      `/${swSewagePath}/api/0/pointIndicator/listIntegrityRate`,
      params,
    );
  };

  // 设备台账列表
  static listDeviceLedgerInfo = (params) => {
    return request.post(
      `/${swSewagePath}/api/device/listDeviceLedgerInfo`,
      params,
    );
  };

  // 仓库信息管理列表
  static storeList = (params) => {
    return request.post(`/${swSewagePath}/api/0/store/list`, params);
  };

  // 仓库信息管理新增
  static storeSave = (params) => {
    return request.post(`/${swSewagePath}/api/0/store/save`, params);
  };

  // 仓库信息管理编辑
  static storeUpdate = (params) => {
    return request.post(`/${swSewagePath}/api/0/store/update`, params);
  };

  // 仓库信息管理删除
  static storeRemove = (params) => {
    return request.post(`/${swSewagePath}/api/0/store/remove`, params);
  };

  // 仓库信息管理根据厂站id获取所有列表
  static storeAllByStation = (params) => {
    return request.post(`/${swSewagePath}/api/0/store/allByStation`, params);
  };

  // 根据仓库id查询备品备件信息
  static listByStoreId = (params) => {
    return request.post(
      `/${swSewagePath}/api/0/storePart/listByStoreId`,
      params,
    );
  };

  // 备品备件批量添加
  static storePartBatchSave = (params) => {
    return request.post(`/${swSewagePath}/api/0/storePart/batchSave`, params);
  };

  // 备品备件列表
  static storePartList = (params) => {
    return request.post(`/${swSewagePath}/api/0/storePart/list`, params);
  };

  // 删除备品备件
  static storePartRemove = (params) => {
    return request.post(`/${swSewagePath}/api/0/storePart/remove`, params);
  };

  // 更新备品备件
  static storePartUpdate = (params) => {
    return request.post(`/${swSewagePath}/api/0/storePart/update`, params);
  };
  // 入库单列表
  static storeReceiptInList = (params) => {
    return request.post(`/${swSewagePath}/api/0/storeReceiptIn/list`, params);
  };

  // 入库单新增
  static storeReceiptInInsert = (params) => {
    return request.post(`/${swSewagePath}/api/0/storeReceiptIn/insert`, params);
  };

  // 入库单修改
  static storeReceiptInUpdate = (params) => {
    return request.post(`/${swSewagePath}/api/0/storeReceiptIn/update`, params);
  };

  // 入库单删除
  static storeReceiptInRemove = (params) => {
    return request.post(`/${swSewagePath}/api/0/storeReceiptIn/remove`, params);
  };

  // 出库单列表
  static storeReceiptOutList = (params) => {
    return request.post(`/${swSewagePath}/api/0/storeReceiptOut/list`, params);
  };

  // 出库单新增
  static storeReceiptOutInsert = (params) => {
    return request.post(
      `/${swSewagePath}/api/0/storeReceiptOut/insert`,
      params,
    );
  };

  // 出库单修改
  static storeReceiptOutUpdate = (params) => {
    return request.post(
      `/${swSewagePath}/api/0/storeReceiptOut/update`,
      params,
    );
  };

  // 出库单删除
  static storeReceiptOutRemove = (params) => {
    return request.post(
      `/${swSewagePath}/api/0/storeReceiptOut/remove`,
      params,
    );
  };

  // bom 列表
  static bomInfoList = (params) => {
    return request.post(`/${swSewagePath}/api/0/bomInfo/list`, params);
  };

  // bom 新增
  static bomInfoSave = (params) => {
    return request.post(`/${swSewagePath}/api/0/bomInfo/save`, params);
  };

  // bom 修改
  static bomInfoUpdate = (params) => {
    return request.post(`/${swSewagePath}/api/0/bomInfo/update`, params);
  };

  // bom 删除
  static bomInfoRemove = (params) => {
    return request.post(`/${swSewagePath}/api/0/bomInfo/remove`, params);
  };

  // 获取摄像头通道列表
  static getDeviceChannelList = (params) => {
    return request.post(
      `/${swSewagePath}/api/hikSec/getDeviceChannelList`,
      params,
    );
  };

  // 根据通道获取播放地址
  static getDevicePreviewUrl = (params) => {
    return request.post(
      `/${swSewagePath}/api/hikSec/getDevicePreviewUrl`,
      params,
    );
  };

  // 工艺单元列表
  static processUnitList = (params) => {
    return request.post(`/${swSewagePath}/api/process/unit/pageList`, params);
  };

  // 工艺单元新增
  static processUnitInsert = (params) => {
    return request.post(`/${swSewagePath}/api/process/unit/insert`, params);
  };

  // 工艺单元修改
  static processUnitUpdate = (params) => {
    return request.post(`/${swSewagePath}/api/process/unit/update`, params);
  };

  // 工艺单元删除
  static processUnitDelete = (params) => {
    return request.post(`/${swSewagePath}/api/process/unit/delete`, params);
  };

  // 设备导出
  static exportDevices = (params) => {
    return request.post(`/${swSewagePath}/api/device/exportDevices`, params, {
      responseType: "blob",
    });
  };

}
